import { createApp } from 'vue'
import { createPinia } from 'pinia'
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import 'element-plus/dist/index.css'
import './styles/index.scss'
import App from './App.vue'
import router from './router'
import { hasPermi } from './directives/permission'
import Icon from './components/Icon'
import i18n from './locales'
import { APP_CONFIG } from './config/app.config'

document.title = `合同管理门户 - ${APP_CONFIG.APP_TITLE}`

const app = createApp(App)
const pinia = createPinia()

// 注册所有 Element Plus 图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

// 注册全局组件
app.component('Icon', Icon)

// 注册权限指令
app.directive('hasPermi', hasPermi)

app.use(pinia)
app.use(router)
app.use(ElementPlus, { locale: zhCn })
app.use(i18n)

app.mount('#app')
